export default __webpack_public_path__ + "static/media/image-heading.png?.bdbe9452";